/*------------------------------------------------------------------------*/
/*  Rodesk default JS functions
/*------------------------------------------------------------------------*/

var rodeskDefaults = (function () {

    /*------------------------------------------------------------------------*/
    /* Modernizr fallback for <img> tags using SVG (will replace SVG with PNG when not supported)
    /* http://bit.ly/XajRsC
    /*------------------------------------------------------------------------*/

    var _modernizrSvg = function() {
        if( !Modernizr.svg ) {
            jQuery('img[src*="svg"]').attr('src', function() {
                return jQuery(this).attr('src').replace('.svg', '.png');
            });
        }
    };

    /*------------------------------------------------------------------------*/
    /*  Open rel=external in new window
    /*------------------------------------------------------------------------*/

    var _relExternal = function() {
        window.open( $(this).attr('href') );
        return false;
    };

    /*------------------------------------------------------------------------*/
    /*  Make link of whole element block
    /*------------------------------------------------------------------------*/

    var _jsBlock = function() {
        var closestHref = $( this ).find("a").not('.js-block-skip').attr("href");
        window.location = closestHref;
        return false;
    };

    /*------------------------------------------------------------------------*/
   /*  Init Image Liquid JS plugin
   /*------------------------------------------------------------------------*/

   var imgLiquidCustom = function( element ) {

       element.each( function( counter, image ) {

           element.imgLiquid({
               onItemFinish: function() {
                   $( element ).css({
                       opacity: '1'
                   });
               }
           });


       });

   };

    /*------------------------------------------------------------------------*/
    /*  Init matchHeight plugin
    /*------------------------------------------------------------------------*/

    var _matchHeight = function( classArray ) {
        $.each( classArray, function(count, element) {
            $( element ).matchHeight();
        });
    };

    /*------------------------------------------------------------------------*/
    /*  Setup event listeners
    /*------------------------------------------------------------------------*/

    var _setupListeners = function( classArray ) {

        // Init events for class=".js-block"
        $(document).on( "click" , ".js-block" , _jsBlock );

        // Init events for rel="external"
        $(document).on( "click" , "a[rel='external']" , _relExternal );

    };

    // Return an object exposed to the public
    return {

        matchHeight:_matchHeight,
        imgLiquidCustom: imgLiquidCustom,

        /**
         * Global functions init
         */
        init: function() {

            // Init several default functions
            _modernizrSvg(); // Run svgModernizr
            _setupListeners(); // Setup the event listeners

        }

    };

})(jQuery); // Fully reference jQuery after this point.
